export default __webpack_public_path__ + "static/toby-0f4ad252a8db7e0c56a393b48f7723f8.jpg";